import React, { useState } from 'react';
import Cards from 'react-credit-cards';
import 'react-credit-cards/lib/styles.scss';
import Input from '../../../components/Input';
import { ACTIONS, INPUT_SIZES, INPUT_TYPES } from '../../../utils/constants';
import { useStateContext } from '../../../context/StateContext';
import style from './form.module.scss';

const paymentForm = [
	{ key: 'number', placeholder: 'Kredi kartı numarası', format: '#### #### #### ####', actionType: ACTIONS.CHANGE_CARD_NUMBER, actionPayload: 'cardNumber' },
	{ key: 'name', placeholder: 'Ad soyad', actionType: ACTIONS.CHANGE_CARD_HOLDER_NAME, actionPayload: 'cardHolderName' },
	{ key: 'expiry', placeholder: 'Son kullanma tarihi', format: '## / ##', actionType: ACTIONS.CHANGE_EXPIRE_DATE, actionPayload: 'expireDate' },
	{ key: 'cvc', placeholder: 'CVC Güvenlik kodu', format: '####', actionType: ACTIONS.CHANGE_CVC, actionPayload: 'cvc' },
];

const PaymentForm = () => {
	const {
		state,
		state: { cvc, expireDate, cardHolderName, cardNumber },
		dispatch
	} = useStateContext();
	const [focus, setFocus] = useState('');

	const handleOnInputChange = ({ value, data }) => {
		dispatch({
			type: data.actionType,
			payload: { [data.actionPayload]: value }
		});
	};

	return (
		<div className={style.container}>
			<div>
				{
					paymentForm?.map(data => (
						<Input
							containerClassName={style.inputContainer}
							key={data.key}
							name={data.key}
							initialValue={state?.[data.actionPayload]}
							placeholder={data.placeholder}
							size={INPUT_SIZES.BIG}
							inputType={data.key !== 'name' && INPUT_TYPES.CURRENCY}
							format={data?.format}
							isPrice={false}
							onBlur={() => setFocus('')}
							onFocus={() => setFocus(data.key)}
							onChange={value => handleOnInputChange({ value, data })}
						/>
					))
				}
			</div>
			<div className={style.creditCard}>
				<Cards
					cvc={cvc}
					expiry={expireDate}
					name={cardHolderName}
					number={cardNumber}
					focused={focus}
				/>
			</div>
		</div>
	);
};

export default PaymentForm;
